import { makeStyles } from '@material-ui/core';

const styles = makeStyles((theme) => ({
  container: {
    paddingTop: 16,
  },
  divider: {
    [theme.breakpoints.up('md')]: {
      height: '100%',
      borderWidth: '0px 0px 0px 1px',
      paddingLeft: 16,
    },
  },
  title: {
    fontSize: 15,
    marginRight: 12,
    fontWeight: 400,
  },
  titleBold: {
    fontSize: 15,
    marginRight: 12,
    fontWeight: 600,
  },
  subtitle: {
    margin: 16,
  },
  subtitleBold: {
    margin: 16,
    fontWeight: 600,
  },
  list: {
    width: '80%',
    marginTop: 16,
  },
  vinculoContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
}));

export default styles;
